<template>
  <div>
    <!-- banner图 -->
    <div class="header">
      <el-carousel type="card" :height="bannerHeight">
        <el-carousel-item v-for="item in slideImageList" :key="item.id">
          <el-image class="slide-image" :src="item.url" :error="loadAgain(item)"
            ><div slot="placeholder" class="image-slot">加载中<span class="dot">...</span></div></el-image
          >
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 研究所介绍 -->
    <div class="border_parent">
      <b-card>
        <b-row type="flex" justify="center">
          <b-col>
            <div class="content">
              <div v-html="content"></div>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <!-- 近期新闻 -->
    <div class="border_parent recent-news-section">
      <b-card class="recent-news-card">
        <div class="recent-news-header">
          <h2 class="recent-news-title">近期新闻</h2>
          <button type="button" class="recent-news-more" @click="moreNews">更多新闻<i class="el-icon-arrow-right"></i></button>
        </div>
        <div v-if="newsList.length" class="recent-news-list">
          <a v-for="item in newsList" :key="item.id" class="recent-news-item" @click.prevent="linkNews(item.id)">
            <div class="recent-news-image">
              <el-image v-if="item.photoUrl" :src="item.photoUrl" fit="cover">
                <div slot="error" class="recent-news-image-placeholder"><i class="el-icon-picture-outline"></i></div>
              </el-image>
              <div v-else class="recent-news-image-placeholder"><i class="el-icon-picture-outline"></i></div>
            </div>
            <div class="recent-news-content">
              <h3 class="recent-news-name" :title="item.name">{{ item.name }}</h3>
              <p class="recent-news-description">{{ item.description }}</p>
            </div>
            <time class="recent-news-date">{{ getDate(item.date) }}</time>
          </a>
        </div>
        <div v-else class="recent-news-empty">暂无新闻</div>
      </b-card>
    </div>
    <!-- 新闻&论文 -->
    <!-- <div class="border_parent">
            <el-row type="flex" :gutter="30" justify="center">
                <el-col :xs="12" :sm="12" :md="10">
                    <div class="border_">
                        <div class="border_second">
                            <span><i class="el-icon-s-order"></i>最新论文</span>                            
                            <span class="border_span">更多论文<i class="el-icon-caret-right"></i></span>
                        </div>
                        <div>
                            <div class="border_content">
                                * <b>Source-Free Open Compound Domain Adaptation in Semantic Segmentation</b>, 
                                Yuyang Zhao, Zhong Zhun*, Zhiming Luo, Gim Hee Lee, Nicu Sebe, 
                                IEEE Transactions on Circuits and Systems for Video Technology, 2022. 
                                <b>(CCF-B)</b>
                            </div>
                        </div>                     
                    </div>
                </el-col>
                <el-col :span="10">
                    <div>
                        <div class="border_second">
                            <span><i class="el-icon-s-order"></i>新闻资讯</span>                            
                            <span class="border_span" @click="moreNews">更多新闻<i class="el-icon-caret-right"></i></span>
                        </div>
                        <div class="border_content" style="height: 20px" v-for="item in newsList" :key="item.id">
                            <a class="border_news" :title="item.name" @click.prevent="linkNews(item.id)">
                                {{item.name}}
                            </a>
                            <div class="border_date">
                                {{getDate(item.time)}}
                            </div>
                        </div>  
                        
                    </div>
                </el-col>
            </el-row>
        </div> -->
  </div>
</template>

<script>
import request from "../utils/request";
export default {
  name: "Index",
  data() {
    return {
      slideImageList: [],
      requestUrl: {
        // getPage: '/article/page',
        introductionUrl: "/article/page",
        getImagePage: "/file/page",
        getNewsPage: "/news/page",
      },
      content: "",
      newsList: [],
      // 浏览器宽度
      screenWidth: 0,
      bannerHeight: "0px",
    };
  },
  created() {
    this.getNewsData();
    this.getSlideImage();
    this.getRecentNews();
  },
  methods: {
    loadAgain(img) {
      console.log("!!!!!!!!!!!!!!", img);
    },
    // 获取简介数据
    getNewsData() {
      request
        .get(this.requestUrl.introductionUrl, {
          params: {
            name: "",
            pageNum: 1,
            pageSize: 1,
            type: 6,
          },
        })
        .then((res) => {
          if (res.code === "200") {
            if (res.data.records.length) {
              this.content = res.data.records[0].content;
            }
          } else {
            this.$message.error("获取失败");
          }
        });
    },
    //获取滑动图片数据
    getSlideImage() {
      request
        .get(this.requestUrl.getImagePage, {
          params: {
            pageNum: 1,
            pageSize: 10000,
            isSlide: "1",
          },
        })
        .then((res) => {
          if (res.code === "200") {
            this.slideImageList = res.data.records;
          } else {
            this.$message.error("获取失败");
          }
        });
    },

    // 获取日期最新的三条新闻
    getRecentNews() {
      request
        .get(this.requestUrl.getNewsPage, {
          params: {
            name: "",
            pageNum: 1,
            pageSize: 1000,
          },
        })
        .then((res) => {
          if (res.code === "200") {
            const records = res.data.records || [];
            this.newsList = [...records]
              .sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0))
              .slice(0, 3);
          } else {
            this.$message.error("获取新闻失败");
          }
        });
    },

    getDate(val) {
      return val ? val.slice(0, 10) : "";
    },

    linkNews(id) {
      this.$router.push({
        name: "details",
        query: {
          newsId: id,
          type: "5",
        },
      });
    },

    moreNews() {
      this.$router.push({ name: "newsList" });
    },

    setSize() {
      // 通过浏览器宽度(图片宽度)实现计算高度
      this.bannerHeight = String((400 / 1920) * this.screenWidth) + "px";
    },
    //#region
    // getNews() {
    //     request.get(this.requestUrl.getPage, {
    //         params: {
    //             name: '',
    //             pageNum: 1,
    //             pageSize: 10,
    //             type: 1
    //         }
    //     }).then(res => {
    //         if (res.code === '200') {
    //             this.newsList = res.data.records;
    //         } else {
    //             this.$message.error("获取失败");
    //         }
    //     })
    // },
    // getDate(val) {
    //     const date = new Date(val);
    //     return format(date, 'yyyy-MM-dd');
    // },
    // linkNews(id) {
    //     this.$router.push({
    //         name: "News",
    //         query: {
    //             articleId: id
    //         }
    //     })
    // },
    // moreNews() {
    //     this.$router.push({ name: "NewsList"});
    // }
    //#endregion
  },
  mounted() {
    // 首次加载时,需要调用一次
    this.screenWidth = window.innerWidth;
    this.setSize();
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.setSize();
    };
  },
};
</script>

<style scoped>
* {
  font: Helvetica, STHeiti STXihei, Microsoft JhengHei, Microsoft YaHei, Tohoma, Arial;
  color: #313131;
}

.header {
  width: 100%;
  margin: 0 auto;
}

@media (max-width: 769px) {
  /* 媒体查询：页面宽度小于等于768px时生效 */
  .border_parent {
    width: 100%;
    margin: auto;
  }
}

@media (min-width: 769px) {
  .border_parent {
    width: 90%;
    margin: auto;
  }
}

.content {
  width: 90%;
  margin: 0 auto;
}

/* 轮播图片样式 */
.slide-image {
  /*设置图片宽度和浏览器宽度一致*/
  width: 100%;
  height: inherit;
}

.recent-news-section {
  margin-top: 24px;
  margin-bottom: 24px;
}

.recent-news-card /deep/ .card-body {
  padding: 22px 5%;
}

.recent-news-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #dfe5ee;
}

.recent-news-title {
  position: relative;
  margin: 0;
  padding-left: 14px;
  color: #002d71;
  font-size: 24px;
  font-weight: bold;
}

.recent-news-title::before {
  position: absolute;
  top: 2px;
  bottom: 2px;
  left: 0;
  width: 4px;
  background-color: #002d71;
  content: "";
}

.recent-news-more {
  padding: 4px 0;
  border: 0;
  background: transparent;
  color: #002d71;
  font-size: 14px;
  cursor: pointer;
}

.recent-news-more i {
  margin-left: 4px;
  color: #002d71;
}

.recent-news-item {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr) 100px;
  gap: 18px;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #e7eaf0;
  text-decoration: none;
  cursor: pointer;
}

.recent-news-item:last-child {
  border-bottom: 0;
}

.recent-news-image,
.recent-news-image .el-image,
.recent-news-image-placeholder {
  width: 150px;
  height: 90px;
}

.recent-news-image {
  overflow: hidden;
  background-color: #f3f5f8;
}

.recent-news-image-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
}

.recent-news-image-placeholder i {
  color: #a6adb8;
  font-size: 26px;
}

.recent-news-name {
  display: -webkit-box;
  overflow: hidden;
  margin: 0 0 8px;
  color: #002d71;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.45;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.recent-news-item:hover .recent-news-name {
  color: #409eff;
}

.recent-news-description {
  display: -webkit-box;
  overflow: hidden;
  margin: 0;
  color: #777;
  font-size: 14px;
  line-height: 1.6;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.recent-news-date {
  color: #999;
  font-size: 14px;
  text-align: right;
}

.recent-news-empty {
  padding: 36px 0 20px;
  color: #999;
  text-align: center;
}

@media (max-width: 769px) {
  .recent-news-section {
    margin-top: 14px;
    margin-bottom: 14px;
  }

  .recent-news-card /deep/ .card-body {
    padding: 16px 6%;
  }

  .recent-news-title {
    font-size: 20px;
  }

  .recent-news-item {
    grid-template-columns: 100px minmax(0, 1fr);
    gap: 8px 12px;
    padding: 12px 0;
  }

  .recent-news-image,
  .recent-news-image .el-image,
  .recent-news-image-placeholder {
    width: 100px;
    height: 68px;
  }

  .recent-news-name {
    margin-bottom: 0;
    font-size: 15px;
  }

  .recent-news-description {
    display: none;
  }

  .recent-news-date {
    grid-column: 2;
    font-size: 12px;
    text-align: left;
  }
}

/* .border_content:last-child {
        border-bottom: none;
    }
    .border_news{
        cursor:pointer;
        width: calc(100% - 110px);
        float: left;
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis; 
    }
    .border_news:hover {
        color: #409EFF;
    }
    .border_date{
        float: right;
        width: 90px;
    }
    .border_content {
        padding-bottom: 10px;
        border-bottom: 2px solid #e7e7e7;
    }
    .border_second{
        height: 30px;
        width: 100%;
        line-height: 30px;
        background-color: #409EFF;
        margin-bottom: 10px;
        font-size: 18px;
        font-family: Microsoft YaHei;
    }
    .border_second span:hover {
        color: #FFFFFF;
        cursor:pointer;
    }
    .border_span{
        float: right;
        margin-right: 1%;
    } */
</style>
